import { httpClient } from '../utils/httpClient';
import {
  NotaActividadPayload,
  NotaActividadResponse,
  NotaActividadMasivoPayload,
} from '../types/notaActividad.types';
import { MatriculaResponse } from '../types/matricula.types';

// ============================================================
// notaActividadService.ts
// httpClient extrae body.data y lanza Error(body.message)
// si success === false.
// ============================================================

export const notaActividadService = {

  // Listar notas por asignación y periodo
  async listarPorAsignacionYPeriodo(
    asignacionAcademicaId: number,
    periodoId: number,
  ): Promise<NotaActividadResponse[]> {
    return httpClient.get<NotaActividadResponse[]>(
      `/notas-actividades/asignacion/${asignacionAcademicaId}/periodo/${periodoId}`
    );
  },

  // Listar notas de un estudiante en una asignación y periodo
  async listarPorMatriculaAsignacionPeriodo(
    matriculaId: number,
    asignacionAcademicaId: number,
    periodoId: number,
  ): Promise<NotaActividadResponse[]> {
    return httpClient.get<NotaActividadResponse[]>(
      `/notas-actividades/matricula/${matriculaId}/asignacion/${asignacionAcademicaId}/periodo/${periodoId}`
    );
  },

  async crear(payload: NotaActividadPayload): Promise<NotaActividadResponse> {
    return httpClient.post<NotaActividadResponse>('/notas-actividades', payload);
  },

  async crearMasivo(payload: NotaActividadMasivoPayload): Promise<NotaActividadResponse[]> {
    return httpClient.post<NotaActividadResponse[]>('/notas-actividades/masivo', payload);
  },

  async modificar(id: number, payload: NotaActividadPayload): Promise<NotaActividadResponse> {
    return httpClient.put<NotaActividadResponse>(`/notas-actividades/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/notas-actividades/${id}`);
  },

  // Listar todas las notas de una matrícula (estudiante) en un periodo
  async listarPorMatriculaYPeriodo(
    matriculaId: number,
    periodoId: number,
  ): Promise<NotaActividadResponse[]> {
    return httpClient.get<NotaActividadResponse[]>(
      `/notas-actividades/matricula/${matriculaId}/periodo/${periodoId}`
    );
  },
};

// ============================================================
// Obtener matrículas (estudiantes) por grado, sección y año
// ============================================================
export const matriculaListService = {

  async listarPorGradoSeccionAnio(
    gradoId: number,
    seccionId: number,
    anioEscolarId: number,
  ): Promise<MatriculaResponse[]> {
    const res = await httpClient.get<MatriculaResponse[] | { content: MatriculaResponse[] }>(
      `/matriculas/grado/${gradoId}/seccion/${seccionId}/anio-escolar/${anioEscolarId}`
    );
    return Array.isArray(res) ? res : (res.content ?? []);
  },
};
